import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  changeTableSortIcons,
  getSortDirectionProperty,
} from "../../../../../system";
import FilterComponent from "../FilterComponent";
import { allSharedComponents } from "../../../../../shared";
import { translationConstants } from "../../../../../constants";
import { centersActions } from "../../../../../redux/actions";
import { authActions } from "../../../../../redux/actions/auth.action";
import { getDataToExport, getExportHeaders, getcolumns } from "../utilities";

const { DataTable, ExportComponent } = allSharedComponents;
const defaultQueryExpression = "id != null ";
const initialGridState = {
  length: 10,
  search: null,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: defaultQueryExpression,
};

let sortingInProgress = false;

const CentersList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const cities = useSelector((state) => state.LoginReducer.cities);
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const centersData = useSelector(
    (state) => state.centersReducer.approvedCentersData?.pageData
  );
  const totalElements = useSelector(
    (state) => state.centersReducer.approvedCentersData?.page?.totalElements
  );

  const getRowData = (data) => {
    dispatch(centersActions.getCenterById(data.id));
    navigate(`/center-profile?centerId=${data.id}`);
  };

  const [totalRows, setTotalRows] = useState(0);
  const [rowData, setRowData] = useState("");
  const [dataToExport, setDataToExport] = useState([]);
  const [columnsToExport, setColumnsToExport] = useState([]);
  const [gridState, setGridState] = useState(initialGridState);
  const [columns, setColumns] = useState(
    getcolumns(t, getRowData, cities, direction, false)
  );
  const [defaultPage, setDefaultPage] = useState(gridState.pageNumber);

  const onSort = (sortedColumn) => {
    sortingInProgress = true;
    setColumns(changeTableSortIcons(columns, sortedColumn));
    const columnDirection = getSortDirectionProperty(sortedColumn);
    setDefaultPage(gridState.pageNumber);
    setGridState({
      ...gridState,
      orderBy: columnDirection ? `${sortedColumn.id} ${columnDirection}` : "id desc",
    });
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgress) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  useEffect(() => {
    setRowData(centersData);
    setTotalRows(totalElements);
    setDataToExport(getDataToExport(centersData, t, cities, direction, false));
    // eslint-disable-next-line
  }, [centersData]);

  useEffect(() => {
    setColumns(getcolumns(t, getRowData, cities, direction, false));
    setColumnsToExport(getExportHeaders(columns));
    // eslint-disable-next-line
  }, [i18n.dir()]);

  useEffect(() => {
    dispatch(centersActions.getAllCenters(gridState));
    sortingInProgress = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setColumns(getcolumns(t, getRowData, cities, direction, false));
    // eslint-disable-next-line
  }, [cities]);

  useEffect(() => {
    setColumnsToExport(getExportHeaders(columns));
  }, [columns]);

  const exportData = () => {
    let dataToSend = {
      ...gridState,
      length: 0,
      orderBy: gridState.orderBy,
    };
    dispatch(centersActions.exportCenterData(dataToSend, 0));
  };

  return (
    <div className="tableContainer">
      <FilterComponent
        isStatusFilterAllowed={true}
        gridState={gridState}
        setGridState={setGridState}
        defaultQueryExpression={defaultQueryExpression}
      >
        <ExportComponent
          isServerSide
          onClick={exportData}
          filename={t(translationConstants.CENTERS_LIST)}
        />
      </FilterComponent>

      <DataTable
        onSort={onSort}
        items={rowData}
        columns={columns}
        gridState={gridState}
        paginationResetDefaultPage
        onChangePage={onChangePage}
        paginationTotalRows={totalRows}
        paginationDefaultPage={defaultPage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    </div>
  );
};

export default CentersList;
